import styled, { css } from "styled-components";
import { CardType } from "./CardAtomModel";
import { BORDER_RADIUS, COLORS, SIZE } from "constants/variables";

export const CardAtomContainer = styled.a`
  text-decoration: none;
`;

export const CardAtomWrapper = styled.div<{ type: CardType }>`
  width: 100%;
  height: 100%;

  ${({ type }) =>
    (type === CardType.PDF_VIEWER || type === CardType.REDIRECT) &&
    css`
      min-height: ${SIZE.max240};
      background-color: ${COLORS.VividAuburn};
      transition: background-color 0.4s ease-out;
      border-radius: ${BORDER_RADIUS.radius32};
      padding: ${SIZE.max40} ${SIZE.max24} ${SIZE.max24} ${SIZE.max40};
      border: 1px solid ${COLORS.AbsoluteWhite};
      display: flex;
      justify-content: space-between;

      :hover {
        background-color: ${COLORS.FaluRed};
      }

      @media (max-width: 1024px) {
        min-height: 100%;
      }
      @media (max-width: 768px) {
        padding: ${SIZE.max24};
        border-radius: ${BORDER_RADIUS.radius16};
      }
    `}
  ${({ type }) =>
    type === CardType.CONTACT &&
    css`
      min-height: ${SIZE.max240};
      background-color: ${COLORS.Orange};
      transition: background-color 0.4s ease-out;
      border-radius: ${BORDER_RADIUS.radius32};
      padding: ${SIZE.max40} ${SIZE.max24} ${SIZE.max24} ${SIZE.max40};
      border: 1px solid ${COLORS.AbsoluteWhite};
      display: flex;
      justify-content: space-between;

      :hover {
        background-color: ${COLORS.Yellow};
      }

      @media (max-width: 1024px) {
        min-height: 100%;
      }

      @media (max-width: 768px) {
        height: 100%;
        padding: ${SIZE.max24};
        border-radius: ${BORDER_RADIUS.radius16};
      }
    `}
`;
export const CardAtomTextWrapper = styled.div`
  /* overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis; */
`;

export const CardAtomIconWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: flex-end;

  @media (max-width: 768px) {
  }
`;

export const CardAtomIcon = styled.img<{ type: CardType }>`
  height: ${({ type }) =>
    type === CardType.CONTACT ? SIZE.max55 : SIZE.max100};

  @media (max-width: 768px) {
    height: ${({ type }) => (type === CardType.CONTACT ? "40px" : "80px")};
    margin-bottom: ${({ type }) =>
      type === CardType.CONTACT ? `${SIZE.max10}` : "0px"};
  }
`;
